import React from "react";
import Footer from "../../components/Footer/Footer";
import AboutUs from "./AboutUs";
import Banner from "./Banner";
import BookACall from "./BookACall";
import CompaniesWorkingWith from "./CompaniesWorkingWith";
import HowWeWork from "./HowWeWork";
import OurServices from "./OurServices";
import OurTeam from "./OurTeam";

function Home() {
  return (
    <main className="page">
      <Banner />
      <OurServices />
      <HowWeWork />
      <CompaniesWorkingWith />
      <AboutUs />
      <OurTeam />
      <BookACall />
      <Footer />
    </main>
  );
}

export default Home;
